// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__hHmGZ","fadein":"style_fadein__3MKrM"};